/**
 * App version surfaced in the UI so we can tell at a glance whether iPad Safari
 * is on the latest Cloudflare Pages build vs. a stale cached one.
 *
 * Two pieces:
 *   - APP_VERSION — human label, bumped manually as part of each "ship" commit.
 *     Keep it in sync with the commit-message prefix (e.g. "v4.4: ...").
 *   - BUILD_SHA   — short git commit SHA injected at build time by Vite
 *     (see `define: __BUILD_SHA__` in vite.config.ts). Auto-bumps even when
 *     APP_VERSION is forgotten, so the displayed string always changes per
 *     deploy. Falls back to `'dev'` in `npm run dev`.
 */
export const APP_VERSION = 'v5.25';

// Injected by Vite's `define` config. Declare for TypeScript.
declare const __BUILD_SHA__: string;
export const BUILD_SHA: string =
  typeof __BUILD_SHA__ !== 'undefined' ? __BUILD_SHA__ : 'dev';

/** What to show in the UI corner — e.g. "v4.4 · a006414" or "v4.4 · dev". */
export const VERSION_LABEL = `${APP_VERSION} · ${BUILD_SHA}`;
